import { User, UsersDataTableModel } from '../../../../types/user'

export enum DARIO_USERS_ACTION_TYPES {
	SET_USERS = 'SET_USERS',
	SET_SEARCH = 'SET_SEARCH',
	SET_LANGUAGES = 'SET_LANGUAGES',
	SET_ORGANIZATIONS = 'SET_ORGANIZATIONS',
	SET_ROLES = 'SET_ROLES',
	SET_TIERS = 'SET_TIERS',
	SET_STATUSES = 'SET_STATUSES',
	SET_SELECTED = 'SET_SELECTED',
}

interface UsersListAction {
	type: DARIO_USERS_ACTION_TYPES.SET_USERS
	payload: Array<User>
}

interface UsersSetSearchAction {
	type: DARIO_USERS_ACTION_TYPES.SET_SEARCH
	payload: string
}

interface UsersSetLanguagesAction {
	type: DARIO_USERS_ACTION_TYPES.SET_LANGUAGES
	payload: string[]
}

interface UsersSetOrganizationsAction {
	type: DARIO_USERS_ACTION_TYPES.SET_ORGANIZATIONS
	payload: string[]
}

interface UsersSetRolesAction {
	type: DARIO_USERS_ACTION_TYPES.SET_ROLES
	payload: string[]
}

interface UsersSetTiersAction {
	type: DARIO_USERS_ACTION_TYPES.SET_TIERS
	payload: string[]
}

interface UsersSetStatusesAction {
	type: DARIO_USERS_ACTION_TYPES.SET_STATUSES
	payload: string[]
}

interface UsersSetSelectedAction {
	type: DARIO_USERS_ACTION_TYPES.SET_SELECTED
	payload: UsersDataTableModel[]
}

export interface UsersState {
	users: Array<User>
	search: string
	expertises: string[]
	languages: string[]
	organizations: string[]
	roles: string[]
	tiers: string[]
	statuses: string[]
	selectedUsers: UsersDataTableModel[]
}

const initialState: UsersState = {
	users: [],
	search: '',
	expertises: [],
	languages: [],
	organizations: [],
	roles: [],
	tiers: [],
	statuses: [],
	selectedUsers: [],
}

type usersActions =
	| UsersListAction
	| UsersSetSearchAction
	| UsersSetLanguagesAction
	| UsersSetOrganizationsAction
	| UsersSetRolesAction
	| UsersSetTiersAction
	| UsersSetStatusesAction
	| UsersSetSelectedAction

export default (state = initialState, action: usersActions): UsersState => {
	switch (action.type) {
		case DARIO_USERS_ACTION_TYPES.SET_USERS: {
			return {
				...state,
				users: action.payload || [],
			}
		}

		case DARIO_USERS_ACTION_TYPES.SET_SEARCH: {
			return {
				...state,
				search: action.payload || '',
			}
		}

		case DARIO_USERS_ACTION_TYPES.SET_LANGUAGES: {
			return {
				...state,
				languages: [...action.payload],
			}
		}

		case DARIO_USERS_ACTION_TYPES.SET_ORGANIZATIONS: {
			return {
				...state,
				organizations: [...action.payload],
			}
		}

		case DARIO_USERS_ACTION_TYPES.SET_ROLES: {
			return {
				...state,
				roles: [...action.payload],
			}
		}

		case DARIO_USERS_ACTION_TYPES.SET_TIERS: {
			return {
				...state,
				tiers: [...action.payload],
			}
		}

		case DARIO_USERS_ACTION_TYPES.SET_STATUSES: {
			return {
				...state,
				statuses: [...action.payload],
			}
		}

		case DARIO_USERS_ACTION_TYPES.SET_SELECTED: {
			return {
				...state,
				selectedUsers: [...action.payload],
			}
		}

		default: {
			return state
		}
	}
}
